// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageJson from '../../package.json';

export const environment = {
  production: false,
  version: packageJson.version,
  authApiUrl: 'https://dev.auth.intranet.techtitute.com',
  apiUrl: 'https://dev.receipts.intranet.techtitute.com',
  translationsApiUrl: 'https://dev.translations.intranet.techtitute.com',
  coreOrigin: 'https://dev.intranet.techtitute.com',
  moduleOrigin: 'http://localhost:4200/',
  modulesApiUrl: 'https://dev.module.intranet.techtitute.com',
  moduleCode: 'receipts-upload',
  keycloak: {
    url: 'https://dev.login.intranet.techtitute.com',
    realm: 'intranet-dev',
    clientId: 'receipts-upload',
  },
  dbg: true,
};
